// Birincil aksiyon + altta seçenekler (Kaydet ▼ Yeni Aç/Kopyala/...)
import React, { useState, useRef, useEffect } from 'react';

export default function CardSplitButton({
  primaryLabel,
  primaryAction,
  options = [],            // [{ label, icon?, onClick, disabled?, hidden?, separator? }]
  loading = false,
  disabled = false,
  variant = 'primary',     // primary | success | danger
  size = 'md',             // sm | md
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const visibleOpts = options.filter(o => !o.hidden);
  const COLORS = {
    primary: 'var(--accent-primary)',
    success: 'var(--success)',
    danger:  'var(--danger)',
  };
  const bgColor = COLORS[variant] || COLORS.primary;
  const padding = size === 'sm' ? '5px 10px' : '7px 14px';
  const fontSize = size === 'sm' ? '0.78rem' : '0.85rem';

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        type="button"
        onClick={primaryAction}
        disabled={disabled || loading}
        style={{
          background: bgColor,
          color: '#fff', border: 'none',
          padding, fontSize, fontWeight: 600,
          borderRadius: visibleOpts.length ? 'var(--r-md) 0 0 var(--r-md)' : 'var(--r-md)',
          cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
          opacity: (disabled || loading) ? 0.6 : 1,
        }}
      >
        {loading ? '⏳ ' : ''}{primaryLabel}
      </button>
      {visibleOpts.length > 0 && (
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          disabled={disabled || loading}
          aria-label="Daha fazla seçenek"
          title="Diğer kaydet seçenekleri"
          style={{
            background: bgColor,
            color: '#fff',
            border: 'none',
            borderLeft: '2px solid rgba(255,255,255,0.4)',
            padding: size === 'sm' ? '5px 12px' : '7px 14px',
            cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
            borderRadius: '0 var(--r-md) var(--r-md) 0',
            opacity: (disabled || loading) ? 0.6 : 1,
            fontSize: '0.95rem',
            fontWeight: 700,
            lineHeight: 1,
            minWidth: 32,
          }}
        >▾</button>
      )}
      {open && visibleOpts.length > 0 && (
        <div style={{
          // Modal footer'da kullanılırken aşağı doğru açılırsa overflow:hidden ile
          // kırpılıyor. O yüzden YUKARI doğru açılıyor.
          position: 'absolute', bottom: 'calc(100% + 4px)', right: 0,
          background: 'var(--bg-card)',
          border: '1px solid var(--border-secondary)',
          borderRadius: 'var(--r-md)',
          minWidth: 220, zIndex: 1100,
          boxShadow: 'var(--shadow-lg)',
          padding: 4,
        }}>
          {visibleOpts.map((opt, i) => {
            if (opt.separator) {
              return <div key={'sep-' + i} style={{ height: 1, background: 'var(--border-secondary)', margin: '4px 6px' }} />;
            }
            return (
              <button
                key={opt.label}
                type="button"
                onClick={() => { setOpen(false); opt.onClick?.(); }}
                disabled={opt.disabled}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  width: '100%', textAlign: 'left',
                  padding: '7px 10px', background: 'transparent', border: 'none',
                  cursor: opt.disabled ? 'not-allowed' : 'pointer',
                  fontSize: '0.82rem',
                  color: opt.disabled ? 'var(--text-tertiary)' : 'var(--text-primary)',
                  borderRadius: 'var(--r-sm)',
                }}
                onMouseEnter={(e) => { if (!opt.disabled) e.currentTarget.style.background = 'var(--bg-secondary)'; }}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                {opt.icon && <span>{opt.icon}</span>}
                <span>{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </span>
  );
}
